import {initializeApp} from "firebase/app";
import {getToken, initializeAppCheck, ReCaptchaEnterpriseProvider} from "firebase/app-check";
import {FIREBASE_CONFIG, RECAPTCHA_ENTERPRISE_SITE_KEY} from "./globals";

// On localhost Firebase rejects requests unless a debug token is registered.
// Setting this flag before initializeAppCheck makes the SDK print a token to
// the browser console on first load; paste it into Firebase Console →
// App Check → Manage debug tokens.
if (process.env.NODE_ENV === 'development') {
  (window as unknown as {FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean}).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

const firebaseApp = initializeApp(FIREBASE_CONFIG);

const appCheck = initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaEnterpriseProvider(RECAPTCHA_ENTERPRISE_SITE_KEY),
  isTokenAutoRefreshEnabled: true,
});

// Shape matches google.maps.MapsAppCheckTokenResult ({token: string}).
export const getAppCheckToken = () => getToken(appCheck, false);
